<script>
    import {getNextInputId} from '../../helper/UIHelper';  
    export let model;
    export let list;
    export let label;
    export let placeholder;
    export let required = false;
    let className = "";
    export {className as class};

    let uid = getNextInputId();


</script>
<div class="{className}">
  {#if label != null}
  <label for="{uid}" class="block text-m font-medium leading-5 text-main">{label}</label>
  {/if}
  <div class="mt-1 rounded-md shadow-sm">
  <select id="{uid}" bind:value={model} required={required} on:change class="mt-1 block form-select w-full py-2 px-3 py-0 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-m sm:leading-5">
    {#if placeholder != null}
        <option selected disabled value="">{placeholder}</option>
    {/if}
    {#each list as item}
      <option value={item.value} class:bold={item.isGroup}>
      {#if !item.isGroup}&nbsp;&nbsp;{/if}
        {item.text}
      </option>
    {/each}
  <select>
  </div>
</div>